export default __webpack_public_path__ + "static/media/BrainBreak cards17.c44c48d8.png";